/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Сервис реализует функционал взаимодействия с внешними партнёрами IoT
 */

/**
 * Сервис для отправки команд и сообщений внешним партнёрам IoT
 */
export class IotConnectManageServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Ключ отправляет внешнему партнёру факт изменения состояния устройства.
   * В данном случае имеется в виду переход состояния домофона из состояния \"нет вызова в квартиру\" -> \"есть вызов в квартиру\".
   * Метод доступен для: admin
   */
  PostManageState = (req?: PostManageStateRequestDto, init?: RequestInit): Promise<PostManageStateResponseDto> => {
    return fm.request<PostManageStateRequestDto, PostManageStateResponseDto>(`${this.host}/iot_connect/api/v1/manage/state`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Внешний партнёр IoT отправляет в Ключ сообщение, что пользователь разъединил свой ID и аккаунт Ключа. Аккаунты на стороне партнёра разъединяются независимо от ответа вендора.
   * Ссылка на раздел документации: https://developers.sber.ru/docs/ru/smarthome/c2c/webhook-post-unlink.
   * Метод доступен для: admin
   */
  PostManageUnlinkUser = (req?: PostManageUnlinkUserRequestDto, init?: RequestInit): Promise<PostManageUnlinkUserResponseDto> => {
    return fm.request<PostManageUnlinkUserRequestDto, PostManageUnlinkUserResponseDto>(`${this.host}/iot_connect/api/v1/manage/unlink_user`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Сообщение об изменении состояния устройства (домофона)
 */
export type PostManageStateRequestDto = {
  /**
   * Ключ состояния
   */
  key?: string
}
/**
 * Ответ
 */
export type PostManageStateResponseDto = {
}
/**
 * Запрос-информирование о разъединении аккаунтов
 */
export type PostManageUnlinkUserRequestDto = {
}
/**
 * Ответ на запрос-информирование о разъединении аккаунтов
 */
export type PostManageUnlinkUserResponseDto = {
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Сообщение об изменении состояния устройства (домофона)
   */
  "PostManageStateRequest": {
    "kind": "class",
    "text": "Сообщение об изменении состояния устройства (домофона)",
    "fields": {
      /**
       * Ключ состояния
       */
      "key": {
        "type": "string",
        "text": "Ключ состояния",
      },
    },
  },
  /**
   * Ответ
   */
  "PostManageStateResponse": {
    "kind": "class",
    "text": "Ответ",
  },
  /**
   * Запрос-информирование о разъединении аккаунтов
   */
  "PostManageUnlinkUserRequest": {
    "kind": "class",
    "text": "Запрос-информирование о разъединении аккаунтов",
  },
  /**
   * Ответ на запрос-информирование о разъединении аккаунтов
   */
  "PostManageUnlinkUserResponse": {
    "kind": "class",
    "text": "Ответ на запрос-информирование о разъединении аккаунтов",
  },
}